import React, { memo } from 'react';
import UseDfpSlot from './UseDfpSlot';

const Skin = () => {

    UseDfpSlot({
        path: '/28253241/depor.com/web_interna_skin',
        size: ['fluid', [1, 1]],
        id: 'gpt_skin',
    });

    return (
        <div id="gpt_skin"></div> 
    )
}

export default memo(Skin);
